import { OrderSession } from "nvs-types";

export type OrderCreationBody = {
  chainId: number;
  contractAddress: string;
  productId: string;
  cancelUrl: string;
  quantity: number;
};

export type OrderCreationResponse = OrderSession;

export enum OrderError {
  SIGN_IN = "SIGN IN",
  ONBOARDING_INCOMPLETE = "ONBOARDING_INCOMPLETE",
  NOT_ELIGIBLE = "NOT ELIGIBLE",
  PURCHASE_LIMIT = "PURCHASE LIMIT",
  SOLD_OUT = "SOLD_OUT",
  ERROR = "ERROR",
}

export enum FavoriteError {
  SIGN_IN = "SIGN IN",
  ERROR = "ERROR",
}
